import Icon from "@material-ui/core/Icon";

import { SortDirectionsEnum, SortPayload } from "@/types/ApiResponse";
import { DataStructure } from "@/components/StaticTable";

interface SortProps<T> {
  column: DataStructure<T>;
  sort?: SortPayload;
  onSort?: (newSorting: SortPayload) => void;
}

function Sort<T>(props: SortProps<T>) {
  const { sort, column, onSort } = props;

  const handleSortClick = (newSort: string) => {
    let sortFilter;

    if (sort?.key !== newSort) {
      sortFilter = {
        direction: SortDirectionsEnum.ASCENDING,
        key: newSort,
      };
    } else if (sort?.direction === SortDirectionsEnum.ASCENDING) {
      sortFilter = {
        direction: SortDirectionsEnum.DESCENDING,
        key: newSort,
      };
    } else if (sort?.direction === SortDirectionsEnum.DESCENDING) {
      sortFilter = null;
    } else {
      sortFilter = {
        direction: SortDirectionsEnum.ASCENDING,
        key: newSort,
      };
    }
    if (onSort) onSort(sortFilter as SortPayload);
  };

  const getSortIcon = (newSort?: string) => {
    if (sort?.key !== newSort) return "fas fa-sort";
    switch (sort?.direction) {
      case sort && SortDirectionsEnum?.ASCENDING:
        return "fas fa-sort-up";
      case sort && SortDirectionsEnum?.DESCENDING:
        return "fas fa-sort-down";
      default:
        return "fas fa-sort";
    }
  };

  return (
    <div style={{ display: "flex", cursor: "pointer" }}>
      <Icon
        style={{ fontSize: 17 }}
        className={getSortIcon(column.sortKey)}
        onClick={() => handleSortClick(column.sortKey as string)}
      />
    </div>
  );
}

export default Sort;
